// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

import PageLayer from "@/Layouts/views/PageLayer";
import AdvisorWashoutLayer from "@/Washouts/views/Layers/Advisors/AdvisorWashoutLayer";
import actionsList from "@Constants/actionsList";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

const positions = supportedSystemPositions();
const POSITION = positions.BODY_SHOP.BODY_SHOP_ESTIMATOR;

export default function BodyShopEstimatorWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_BODY_SHOP_ESTIMATOR_COMPENSATION,
	};

	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<AdvisorWashoutLayer position={POSITION} actions={actions} positionType={"Producer"} />
		</PageLayer>
	);
}
